import React from 'react';

export const Add = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="#3A0092"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7 13.5625C6.80625 13.5625 6.64063 13.4938 6.50313 13.3563C6.36563 13.2188 6.29688 13.0531 6.29688 12.8594V7.70312H1.14062C0.946875 7.70312 0.78125 7.63438 0.64375 7.49688C0.50625 7.35938 0.4375 7.19375 0.4375 7C0.4375 6.80625 0.50625 6.64063 0.64375 6.50313C0.78125 6.36563 0.946875 6.29688 1.14062 6.29688H6.29688V1.14062C6.29688 0.946875 6.36563 0.78125 6.50313 0.64375C6.64063 0.50625 6.80625 0.4375 7 0.4375C7.19375 0.4375 7.35938 0.50625 7.49688 0.64375C7.63438 0.78125 7.70312 0.946875 7.70312 1.14062V6.29688H12.8594C13.0531 6.29688 13.2188 6.36563 13.3563 6.50313C13.4938 6.64063 13.5625 6.80625 13.5625 7C13.5625 7.19375 13.4938 7.35938 13.3563 7.49688C13.2188 7.63438 13.0531 7.70312 12.8594 7.70312H7.70312V12.8594C7.70312 13.0531 7.63438 13.2188 7.49688 13.3563C7.35938 13.4938 7.19375 13.5625 7 13.5625Z" />
  </svg>
);
